/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OnboardingConfigProviderListEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const onboardingConfigProviderListEntrypoint: EntryPoint<
	OnboardingConfigProviderListEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<OnboardingConfigProviderListEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-jira-find-onboarding-list-config-provider" */ './OnboardingConfigProviderListEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
